import { render } from "./WardCheckin.vue?vue&type=template&id=25c7e73a&scoped=true"
import script from "./WardCheckin.vue?vue&type=script&lang=js"
export * from "./WardCheckin.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25c7e73a"]])

export default __exports__